import { SelectProps } from './select.props';

export const SelectPresets: SelectProps = {
  labelProperty: 'name',
  multiple: false,
  options: [],
  placeholderTx: 'common.selectPlaceholder',
  valueProperty: 'id',
};
